/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../../js/global";
	import * as helper from "../../../js/helper";
	import full_loading from "../../components/full-loading.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
        },
		name:'dashboard_widget',
        props: { 
            show_shared: {
                type: Boolean,
                default:false
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
				profile: null,
			}
		},
        mounted(){
            this.load_data();
        },
		methods: {
            load_data: async function (event) {
                this.loading = true;
                global.emitter.emit("show-full-loading");
                let params = {};
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.get_my_profile",
                        type: "GET",
                        data: params //for GET request
                        // data: JSON.stringify(params) //for POST request
                    });
                    this.profile = res.message;
                    this.profile.image = new global.image_file({
                        link : res.message.image,
                        link_name : res.message.image_name
                    });
                    this.$forceUpdate();
                } catch (e) {
                    this.exceptions = helper.showException(e);
                }
                global.emitter.emit("hide-full-loading");
                this.loading = false
            },
            async save_profile(){
				try {
					global.emitter.emit("show-full-loading");
					let params = this.profile;
                    
					let res = await $.ajax({
						headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
						url: "/api/method/maalek.api.save_profile",
						type: "POST",
						// data: params //for GET request
						data: JSON.stringify(params) //for POST request
					});
					global.emitter.emit("hide-full-loading");
                    helper.showSuccess("Profile saved",()=>{
						location.reload();
					});
				} catch (e) {
					global.emitter.emit("hide-full-loading");
                    var exceptions = helper.showException(e);
				}
			},
            pickFile () {
                let input = null;
                let files = null;
                input = this.$refs.file_input;
                files = input.files;
                if (files && files[0]) {
                    const single_file = files[0];
                    let reader = new FileReader;
                    reader.onload = e => {
                        this.profile.image = new global.image_file({
                            data : e.target.result,
                            file : single_file.name
                        });
                    }
                    reader.readAsDataURL(single_file);
                    this.$forceUpdate();
                }
            },
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.profile
    ? _c(
        "div",
        { staticClass: "edit-profile" },
        [
          _c("full_loading"),
          _vm._v(" "),
          _c("div", { staticClass: "information d-flex align-items-center" }, [
            _c("label", {
              staticClass: "imagePreviewWrapper",
              style: {
                "background-image":
                  "url(" +
                  (_vm.profile.image.link
                    ? _vm.profile.image.link
                    : _vm.profile.image.data) +
                  ")"
              },
              attrs: { for: "file_input" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "file-upload-account-info" }, [
              _c("input", {
                ref: "file_input",
                staticClass: "inputfile",
                attrs: {
                  type: "file",
                  name: "file",
                  id: "file_input",
                  accept: "image/png, image/gif, image/jpeg"
                },
                on: {
                  input: function($event) {
                    return _vm.pickFile()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "upload border-radius",
                  attrs: { for: "file_input" }
                },
                [
                  _c("i", { staticClass: "ri-link" }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.helper.t("Upload Image")) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("form", { staticClass: "contact-information" }, [
            _c("h3", [_vm._v(_vm._s(_vm.helper.t("Contact Information")))]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v(_vm._s(_vm.helper.t("Mobile No")))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.mobile,
                        expression: "profile.mobile"
                      }
                    ],
                    staticClass: "form-control border-radius",
                    attrs: { type: "text", disabled: "" },
                    domProps: { value: _vm.profile.mobile },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.profile, "mobile", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.helper.t("Full Name")) + " "),
                    _vm.profile.nafath_verified == 1
                      ? _c(
                          "small",
                          {
                            staticStyle: {
                              color: "#11998e",
                              "font-size": "x-small"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa-solid fa-circle-check"
                            }),
                            _vm._v(" " + _vm._s(_vm.helper.t("Verified")))
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.full_name,
                        expression: "profile.full_name"
                      }
                    ],
                    staticClass: "form-control border-radius",
                    attrs: {
                      type: "text",
                      placeholder: _vm.helper.t("Full Name"),
                      disabled: _vm.profile.nafath_verified == 1
                    },
                    domProps: { value: _vm.profile.full_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.profile, "full_name", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v(_vm._s(_vm.helper.t("Email")))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.email,
                        expression: "profile.email"
                      }
                    ],
                    staticClass: "form-control border-radius",
                    attrs: {
                      type: "email",
                      placeholder: _vm.helper.t("Email")
                    },
                    domProps: { value: _vm.profile.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.profile, "email", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm.frappe.user_roles.includes("Agency") || true
                ? _c("div", { staticClass: "col-lg-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v(_vm._s(_vm.helper.t("About Me")))]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.profile.bio,
                            expression: "profile.bio"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        attrs: { name: "massage", cols: "30", rows: "6" },
                        domProps: { value: _vm.profile.bio },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.profile, "bio", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 col-md-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn default-btn",
                    attrs: { role: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.save_profile()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.helper.t("Save Changes")) +
                        "\n                "
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e353a510_0", { source: "\n.imagePreviewWrapper {\n    width: 20%;\n    padding-top: 20%;\n    display: block;\n    cursor: pointer;\n    background-color: aliceblue;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/account/edit-profile.vue"],"names":[],"mappings":";AAgKA;IACA,UAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;IACA,2BAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;AACA","file":"edit-profile.vue","sourcesContent":["<template>\n    <div v-if=\"profile\" class=\"edit-profile\">\n        <full_loading></full_loading>\n        <div class=\"information d-flex align-items-center\">\n            <label for=\"file_input\"\n                class=\"imagePreviewWrapper\"\n                :style=\"{ 'background-image': `url(${profile.image.link?profile.image.link:profile.image.data})` }\">\n            </label>\n            <div class=\"file-upload-account-info\">\n                <input type=\"file\" name=\"file\" id=\"file_input\"\n                    class=\"inputfile\"\n                    @input=\"pickFile()\"\n                    accept=\"image/png, image/gif, image/jpeg\"\n                    ref=\"file_input\">\n                <label for=\"file_input\" class=\"upload border-radius\">\n                    <i class=\"ri-link\"></i>\n                    {{ helper.t(\"Upload Image\") }}\n                </label>\n            </div>\n        </div>\n\n        <form class=\"contact-information\">\n            <h3>{{ helper.t(\"Contact Information\") }}</h3>\n            <div class=\"row\">\n                <div class=\"col-lg-4\">\n                    <div class=\"form-group\">\n                        <label>{{ helper.t(\"Mobile No\") }}</label>\n                        <input v-model=\"profile.mobile\" type=\"text\" class=\"form-control border-radius\" disabled>\n                    </div>\n                </div>\n                <div class=\"col-lg-4\">\n                    <div class=\"form-group\">\n                        <label>{{ helper.t(\"Full Name\") }} <small v-if=\"profile.nafath_verified == 1\" style=\"color:#11998e; font-size: x-small;\"><i class=\"fa-solid fa-circle-check\"></i> {{ helper.t(\"Verified\") }}</small></label>\n                        <input v-model=\"profile.full_name\" type=\"text\" class=\"form-control border-radius\" :placeholder=\"helper.t('Full Name')\" :disabled=\"profile.nafath_verified == 1\">\n                    </div>\n                </div>\n                <div class=\"col-lg-4\">\n                    <div class=\"form-group\">\n                        <label>{{ helper.t(\"Email\") }}</label>\n                        <input v-model=\"profile.email\" type=\"email\" class=\"form-control border-radius\" :placeholder=\"helper.t('Email')\">\n                    </div>\n                </div>\n                <div v-if=\"frappe.user_roles.includes('Agency') || true\" class=\"col-lg-12\">\n                    <div class=\"form-group\">\n                        <label>{{ helper.t(\"About Me\") }}</label>\n                        <textarea v-model=\"profile.bio\" name=\"massage\" cols=\"30\" class=\"form-control border-radius\" rows=\"6\"></textarea>\n                    </div>\n                </div>\n                \n                <div class=\"col-lg-6 col-md-6\">\n                    <button\n                        @click.prevent=\"save_profile()\"\n                        role=\"button\"\n                        class=\"btn default-btn\">\n                        {{ helper.t(\"Save Changes\") }}\n                    </button>\n                </div>\n            </div>\n        </form>\n    </div>\n</template>\n\n<script>\n\timport * as global from \"../../../js/global\";\n\timport * as helper from \"../../../js/helper\";\n\timport full_loading from \"../../components/full-loading.vue\";\n\texport default{\n        components: {\n            full_loading:full_loading,\n        },\n\t\tname:'dashboard_widget',\n        props: { \n            show_shared: {\n                type: Boolean,\n                default:false\n            },\n        },\n\t\tdata() {\n\t\t\treturn {\n                global,\n                helper,\n                frappe,\n                is_loading:false,\n\t\t\t\tprofile: null,\n\t\t\t}\n\t\t},\n        mounted(){\n            this.load_data();\n        },\n\t\tmethods: {\n            load_data: async function (event) {\n                this.loading = true;\n                global.emitter.emit(\"show-full-loading\");\n                let params = {};\n                try {\n                    let res = await $.ajax({\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\n                        url: \"/api/method/maalek.api.get_my_profile\",\n                        type: \"GET\",\n                        data: params //for GET request\n                        // data: JSON.stringify(params) //for POST request\n                    });\n                    this.profile = res.message;\n                    this.profile.image = new global.image_file({\n                        link : res.message.image,\n                        link_name : res.message.image_name\n                    });\n                    this.$forceUpdate();\n                } catch (e) {\n                    this.exceptions = helper.showException(e);\n                }\n                global.emitter.emit(\"hide-full-loading\");\n                this.loading = false\n            },\n            async save_profile(){\n\t\t\t\ttry {\n\t\t\t\t\tglobal.emitter.emit(\"show-full-loading\");\n\t\t\t\t\tlet params = this.profile;\n                    \n\t\t\t\t\tlet res = await $.ajax({\n\t\t\t\t\t\theaders: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\n\t\t\t\t\t\turl: \"/api/method/maalek.api.save_profile\",\n\t\t\t\t\t\ttype: \"POST\",\n\t\t\t\t\t\t// data: params //for GET request\n\t\t\t\t\t\tdata: JSON.stringify(params) //for POST request\n\t\t\t\t\t});\n\t\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\n                    helper.showSuccess(\"Profile saved\",()=>{\n\t\t\t\t\t\tlocation.reload();\n\t\t\t\t\t});\n\t\t\t\t} catch (e) {\n\t\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\n                    var exceptions = helper.showException(e);\n\t\t\t\t}\n\t\t\t},\n            pickFile () {\n                let input = null;\n                let files = null;\n                input = this.$refs.file_input;\n                files = input.files;\n                if (files && files[0]) {\n                    const single_file = files[0];\n                    let reader = new FileReader;\n                    reader.onload = e => {\n                        this.profile.image = new global.image_file({\n                            data : e.target.result,\n                            file : single_file.name\n                        });\n                    }\n                    reader.readAsDataURL(single_file);\n                    this.$forceUpdate();\n                }\n            },\n\t\t},\n\t\tcomputed:{\n\t\t}\n\t}\n</script>\n\n<style>\n.imagePreviewWrapper {\n    width: 20%;\n    padding-top: 20%;\n    display: block;\n    cursor: pointer;\n    background-color: aliceblue;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/account/edit-profile.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__